import React, {useState,useEffect} from "react";
import PropTypes from "prop-types";

import { Container } from "react-bootstrap";

const CurrentYear = () => {
  const [currentYear, setCurrentYear] = useState(null);

  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);

  return currentYear ? <span>{currentYear}</span> : null;

}

const Footer = ({ frontmatter }) => {
  if (!frontmatter) {
    return null;
  }

  const {
    copyright,
  } = frontmatter;

  return (
    <footer className="footer py-3">
      <Container>
  <p className="text-center text-muted">{copyright} <CurrentYear /></p>
      </Container>
    </footer>
  );
};

Footer.propTypes = {
  frontmatter: PropTypes.object,
};

Footer.defaultProps = {
  frontmatter: null,
};

export default Footer;
